export default __webpack_public_path__ + "static/DINPro-Bold-d3c192a5cb57e7531db9d3e4310c525f.otf";